import { useTheme } from '@/hooks/useTheme'
import { SunIcon } from '@/components/ui/icons/SunIcon'
import { MoonIcon } from '@/components/ui/icons/MoonIcon'
import { cn } from '@/utils/cn'
import { iconFill } from '@/components/ui/buttonStyles'

interface ThemeToggleProps {
  className?: string
}

/**
 * Filled dark/light toggle. Reads/writes the shared theme
 * (persisted under localStorage `theme`, dark by default). Reuse this
 * everywhere instead of re-implementing the toggle markup.
 */
export function ThemeToggle({ className }: ThemeToggleProps) {
  const { dark, toggleDark } = useTheme()

  return (
    <button
      type="button"
      onClick={toggleDark}
      className={cn(
        iconFill,
        className,
      )}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {dark ? <SunIcon /> : <MoonIcon />}
    </button>
  )
}
